export const paymentMethodListProps = () => ({
  selectedPaymentMethods: {
    type: String,
    required: false,
    default: null
  },
  modePaiementHabituel: {
    type: Object,
    required: false,
    default() {
      return null;
    }
  },
  paymentMethods: {
    type: Array,
    required: true
  },
  paymentMethodsInfos: {
    type: Object,
    required: true
  },
  montantTotalTtc: {
    type: [String, Number],
    required: true
  },
  magasinAllowCodePromo: {
    type: Boolean,
    required: true
  },
  isPorteurCarteCora: {
    type: Boolean,
    required: true
  },
  carteCoraIsMalinPlus: {
    type: Boolean,
    required: false,
    default: false
  },
  isPorteurCarteMalin: {
    type: Boolean,
    required: true
  },
  typePanier: {
    type: String,
    required: false,
    default: "drive"
  },
  tirelire: {
    type: Object,
    required: false,
    default: null
  }
})

export const paymentMethodListEmits = () => ([
  "modePaiementSelected",
  "processPaiement"
])

export const usePaymentMethodList = (props, context, popinMultiPayRef) => {
  const selectedId = ref(null);

  const allPaymentMethods = computed(() => {
    return props.modePaiementHabituel ? [props.modePaiementHabituel, ...props.paymentMethods] : props.paymentMethods
  })

  const modePaiementSelected = (pm) => {
    context.emit("modePaiementSelected", pm);
  }
  const processPaiement = (evt) => {
    context.emit("processPaiement", evt);
  }
  const openPopinMultiPay = (echeancier) => {
    popinMultiPayRef.value.openPopinMultiPay(echeancier)
  }
  const useDiscount = (modePaiement) => {
    return props.magasinAllowCodePromo && props.typePanier !== "ldd" && modePaiement.attributes.compatible_code_promo
  }

  return {
    selectedId,
    allPaymentMethods,
    modePaiementSelected,
    processPaiement,
    openPopinMultiPay,
    useDiscount
  }
}